import { createAction } from '@reduxjs/toolkit';

import {
  ICommon,
  IPage,
  IMediaResource,
} from './interfaces';

export interface ILoadDataPayload {
  type?: string,
  payload: {
    cardType: string,
    cardParam: string,
    cardCode: string,
    pages?: number[] | null,
  }
}

export interface ILoadProgressPayload {
  type?: string,
  payload: {
    percent: number,
  }
}

export interface ILoadErrorPayload {
  type?: string,
  payload: {
    message: string,
  }
}

export interface ISetDataPayload {
  type?: string,
  payload: {
    common: ICommon,
    pages: Array<IPage>,
    resources: Array<IMediaResource>,
  }
}

export interface IUpdatePagePayload {
  type?: string,
  payload: {
    updateId: string,
    page: IPage,
    addResources: Array<IMediaResource>
  }
}

type TCardStatus = 'init' | 'data-loading' | 'data-loaded' | 'resources-loading' | 'resources-loaded' | 'ready';

export interface ISetStatusPayload {
  type?: string,
  payload: {
    status: TCardStatus,
  }
}

type TCardState = 'closed' | 'opened';

export interface ISetStatePayload {
  type?: string,
  payload: {
    state: TCardState,
  }
}

export const setStatus = createAction('CARD_SET_STATUS', (status: TCardStatus): ISetStatusPayload => ({
  payload: {
    status,
  },
}));

export const setState = createAction('CARD_SET_STATE', (state: TCardState): ISetStatePayload => ({
  payload: {
    state,
  },
}));

export const sendOpened = createAction('CARD_SEND_STATE');

export const loadData = createAction('CARD_LOAD_DATA', (
  cardType: string,
  cardParam: string,
  cardCode: string,
  options: {
    pages?: number[] | null,
    mode?: string,
  },
) => ({
  payload: {
    cardType,
    cardParam,
    cardCode,
    options,
  },
}));

export const loadProgress = createAction('CARD_LOAD_PROGRESS', (percent: number): ILoadProgressPayload => ({
  payload: {
    percent,
  },
}));

export const loadError = createAction('CARD_LOAD_ERROR', (message: string): ILoadErrorPayload => ({
  payload: {
    message,
  },
}));

export const logLoadingError = createAction('CARD/LOG_LOADING_ERROR', (message) => ({
  payload: {
    message,
  },
}));

export const setData = createAction('CARD_SET_DATA', (
  common: ICommon,
  pages: Array<IPage>,
  resources: Array<IMediaResource>,
): ISetDataPayload => ({
  payload: {
    common: { ...common },
    pages: [...pages],
    resources: [...resources],
  },
}));

export const updatePage = createAction('CARD_UPDATE_PAGE', (updateId: string, page: IPage, addResources: Array<IMediaResource> = []): IUpdatePagePayload => ({
  payload: {
    updateId,
    page,
    addResources,
  },
}));

export const setPhysicalGiftOpened = createAction('card/setPhysicalGiftOpened');
